import { useState } from "react";
import { inboxForTopic, queueSupportNote, SUPPORT_TOPICS } from "../../js/api/supportMail";

const EMPTY = { topic: "general", name: "", email: "", message: "", technical: "" };

export default function SupportMailForm({ lead }) {
  const [form, setForm] = useState(EMPTY);
  const [saved, setSaved] = useState(null);

  const inbox = inboxForTopic(form.topic);

  function update(event) {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  }

  function submit(event) {
    event.preventDefault();
    const result = queueSupportNote(form);
    setSaved(result);
    window.location.href = result.mailto;
  }

  if (saved) {
    return (
      <p className="confirm-banner">
        Thank you. Your note is held on this device and addressed to {saved.inbox.email}. If your
        mail window did not open, write us at that address anytime.
      </p>
    );
  }

  return (
    <form className="card support-mail" onSubmit={submit} style={{ maxWidth: "36rem" }}>
      {lead ? <p className="page-lead">{lead}</p> : null}
      <label className="field">
        <span className="field-label">How can we help?</span>
        <select className="field-select" name="topic" value={form.topic} onChange={update}>
          {SUPPORT_TOPICS.map((topic) => (
            <option key={topic.id} value={topic.id}>
              {topic.label}
            </option>
          ))}
        </select>
      </label>
      <p className="muted">
        This note goes to {inbox.email}. During Beta, replies may take a short while — we still read
        every one.
      </p>
      <label className="field">
        <span className="field-label">Name</span>
        <input className="field-input" name="name" value={form.name} onChange={update} required />
      </label>
      <label className="field">
        <span className="field-label">Email</span>
        <input
          className="field-input"
          name="email"
          type="email"
          value={form.email}
          onChange={update}
          required
        />
      </label>
      <label className="field">
        <span className="field-label">Your note</span>
        <textarea
          className="field-textarea"
          name="message"
          rows={5}
          value={form.message}
          onChange={update}
          required
        />
      </label>
      {inbox.allowTechnical ? (
        <label className="field">
          <span className="field-label">If something is not working — extra detail (optional)</span>
          <textarea
            className="field-textarea"
            name="technical"
            rows={3}
            value={form.technical}
            onChange={update}
            placeholder="What you were doing, and what you hoped would happen."
          />
        </label>
      ) : null}
      <button className="primary-btn" type="submit">
        Send
      </button>
    </form>
  );
}
